export default __webpack_public_path__ + "static/media/cone_red.0397d889.png";